var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHotro = function SvgHotro(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7781 10.4443V12.8888C14.7781 14.2389 13.6838 15.3332 12.3337 15.3332H8.66699V14.111H12.3337C13.0088 14.111 13.5559 13.5639 13.5559 12.8888V10.4443H14.7781Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 7.38867H5.61127V12.8887H3.16683C2.15404 12.8887 1.3335 12.0681 1.3335 11.0553V7.38867ZM2.55572 8.61089V11.0553C2.55572 11.3931 2.82906 11.6664 3.16683 11.6664H4.38905V8.61089H2.55572Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7.38867H14.7778V11.0553C14.7778 12.0681 13.9572 12.8887 12.9444 12.8887H10.5V7.38867ZM11.7222 8.61089V11.6664H12.9444C13.2822 11.6664 13.5556 11.3931 13.5556 11.0553V8.61089H11.7222Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 7.38873C1.3335 3.67605 4.34304 0.666504 8.05572 0.666504C11.7684 0.666504 14.7779 3.67605 14.7779 7.38873V8.61095H13.5557V7.38873C13.5557 4.35107 11.0934 1.88873 8.05572 1.88873C5.01806 1.88873 2.55572 4.35107 2.55572 7.38873V8.61095H1.3335V7.38873Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHotro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hotro.bab27705.svg";
export { ForwardRef as ReactComponent };